module.exports = __webpack_public_path__ + "media/drumroll8s.a2b1d8aa.mp3";